import React from "react";
import ReactHtmlParser from "react-html-parser";

import uuid from "react-native-uuid";
import { convertToRaw } from "draft-js";
import HTMLtoDraft from "./HTMLtoDraft/HTMLtoDraft";

export const normaliseCellData = cell => {
  if (typeof cell === "string") {
    return {
      attributes: {
        id: uuid.v4(),
      },
      data: cell,
    };
  }
  if (typeof cell === "number") {
    return {
      attributes: {
        id: uuid.v4(),
      },
      data: cell.toString(10),
    };
  }
  if ("html" in cell) {
    const contentState = HTMLtoDraft(cell.html);
    // For the first time the document is uploaded an html key is sent. This has to be converted to editostate.
    return {
      attributes: cell.attributes,
      data: {
        data: convertToRaw(contentState),
        currentContent: convertToRaw(contentState),
      },
    };
  }
  if (cell instanceof Object) {
    const { attributes, data, text, value, metadata: rowMetaData } = cell;
    const metadata = attributes || rowMetaData || {};
    let cellValue = text || value || data;
    if (metadata.type === "checkbox") {
      cellValue = Boolean(cellValue);
    } else {
      cellValue = cellValue || "";
    }
    metadata.id = metadata.id || uuid.v4();
    return {
      attributes: metadata,
      data: cellValue,
    };
  }
  return cell;
};

export const normaliseRowData = row => {
  let rowData = [];
  let metadata = {};
  if (Array.isArray(row)) {
    rowData = row;
  } else {
    const { attributes, data, metadata: rowMetaData } = row;
    rowData = data;
    metadata = attributes || rowMetaData || {};
  }
  const data = [];
  rowData.forEach(cell => data.push(normaliseCellData(cell)));

  // get the number of columns for this row
  metadata.columnCount = rowData.length;
  metadata.id = metadata.id || uuid.v4();
  return {
    attributes: metadata,
    data,
  };
};

export const normaliseTableData = (table, type, hiddenCols) => {
  let tableData = [];
  let metadata = {};
  if (Array.isArray(table)) {
    tableData = table;
  } else {
    const { attributes, data, metadata: tableMetaData } = table;
    tableData = data;
    metadata = attributes || tableMetaData || {};
  }

  let data = [];
  let columns = 0;
  if (type === "gSheet") {
    // in case of gsheet avoid normaliseRowData()
    data = tableData;
    columns = metadata.columnCount;
  } else {
    tableData.forEach(row => data.push(normaliseRowData(row)));
    columns =
      Array.isArray(data) && data.length > 0
        ? Math.max(
            ...data.map(row => {
              const { attributes } = row;
              return attributes.columnCount;
            }),
          )
        : 0;
  }
  metadata.rowCount = data.length;
  metadata.columnCount = columns;
  metadata.columnWidth = metadata.columnWidth || [];
  metadata.hiddenCols = hiddenCols || [];

  if (columns !== 0) {
    metadata.columnWidth = [...Array(columns)].map((_, i) =>
      metadata.columnWidth[i] ? metadata.columnWidth[i] : "100px",
    );
  }
  return {
    attributes: metadata,
    data,
  };
};

const renderGSheetCell = (cellDataList, hiddenCols, isHeader) =>
  cellDataList.map((cellData, index) => {
    const hdnCols = hiddenCols || [];
    if (!hdnCols.includes(index)) {
      if (isHeader) {
        return <th>{ReactHtmlParser(cellData.data.html)}</th>;
      }
      return <td>{ReactHtmlParser(cellData.data.html)}</td>;
    }
    return null;
  });

export const renderGSheetTable = (rowDataList, hiddenCols) => {
  let hasHeaders = false;
  if (rowDataList.length > 0) hasHeaders = rowDataList[0].attributes.header;
  const tableView = [];
  let tableHeaders = [];
  let tableBody = [];
  if (hasHeaders) {
    tableHeaders = (
      <tr>{renderGSheetCell(rowDataList[0].data, hiddenCols, true)}</tr>
    );
    tableHeaders = <thead>{tableHeaders}</thead>;
  }
  tableBody = rowDataList.map((rowData, index) => {
    if (hasHeaders && index === 0) {
      return null;
    }
    return <tr>{renderGSheetCell(rowData.data, hiddenCols)}</tr>;
  });
  tableBody = <tbody>{tableBody}</tbody>;
  if (hasHeaders) {
    tableView.push(tableHeaders);
    tableView.push(tableBody);
  } else {
    tableView.push(tableBody);
  }
  const table = <table className="google-sheet-table">{tableView}</table>;
  return table;
};



// WEBPACK FOOTER //
// ./src/utils/tableUtils.js